const comments = [
  {
    name: '光影追随者',
    text: '97影院真的太良心了，片源更新速度超快，《流浪地球3》刚下院线没多久就可以在线看了，画质还特别清晰。',
    time: '3天前',
    avatar: 'https://readdy.ai/api/search-image?query=Cinema%20enthusiast%20avatar%20portrait%2C%20warm%20tone%2C%20simple%20background%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-c1-97&orientation=squarish',
  },
  {
    name: '电影发烧友小王',
    text: '收藏了多年电影资源的老影迷表示，这里片库规模真的很大，很多冷门经典都能找到，画质比很多平台都好。',
    time: '5天前',
    avatar: 'https://readdy.ai/api/search-image?query=Asian%20male%20casual%20portrait%2C%20warm%20lighting%2C%20simple%20studio%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-c2-97&orientation=squarish',
  },
  {
    name: '周末宅家党',
    text: '周末一口气刷了五部电影，全程不卡顿！手机投屏到电视上效果也很棒，家庭影院体验拉满。',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20person%20cozy%20portrait%2C%20warm%20home%20lighting%2C%20simple%20background%2C%20relaxed%20casual%20style&width=100&height=100&seq=avatar-c3-97&orientation=squarish',
  },
  {
    name: '科幻迷小李',
    text: '科幻片专区太棒了，从《2001太空漫游》到《沙丘》，经典和新片都能找到，而且还有专题合集，追片神器！',
    time: '1周前',
    avatar: 'https://readdy.ai/api/search-image?query=Tech%20enthusiast%20portrait%2C%20warm%20ambient%20lighting%2C%20simple%20background%2C%20modern%20casual%20style&width=100&height=100&seq=avatar-c4-97&orientation=squarish',
  },
  {
    name: '港片怀旧档',
    text: '终于在97影院找到了高清修复版的《东邪西毒》和《阿飞正传》，港片专区简直就是宝藏，每天重温一部经典。',
    time: '2周前',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20person%20portrait%20with%20warm%20expression%2C%20soft%20lighting%2C%20simple%20background%2C%20nostalgic%20style&width=100&height=100&seq=avatar-c5-97&orientation=squarish',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          影迷评价
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          来自各地影迷的真实观影反馈
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {comments.map((c, i) => (
            <div
              key={i}
              className={`bg-background-50 border border-background-200/70 rounded-xl p-5 ${i === 3 && comments.length === 5 ? 'lg:col-start-2' : ''}`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {c.text}
              </p>
              <div className="flex items-center gap-1 mt-3">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-accent-400 text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}